export const SuppliesActionTypes = {
    LOGOUT: 'LOGOUT',
    COMMON_ERROR: 'COMMON_ERROR',

    ADD_SUPPLIES_CATEGORY_REQUEST: 'ADD_SUPPLIES_CATEGORY_REQUEST',
    ADD_SUPPLIES_CATEGORY_REQUEST_SUCCESS: 'ADD_SUPPLIES_CATEGORY_REQUEST_SUCCESS',
    ADD_SUPPLIES_CATEGORY_REQUEST_ERROR: 'ADD_SUPPLIES_CATEGORY_REQUEST_ERROR',
    ADD_SUPPLIES_CATEGORY_REQUEST_STATUS: 'ADD_SUPPLIES_CATEGORY_REQUEST_STATUS',

    SUPPLIES_CATEGORY_LIST_REQUEST: 'SUPPLIES_CATEGORY_LIST_REQUEST',
    SUPPLIES_CATEGORY_LIST_REQUEST_SUCCESS: 'SUPPLIES_CATEGORY_LIST_REQUEST_SUCCESS',
    SUPPLIES_CATEGORY_LIST_REQUEST_ERROR: 'SUPPLIES_CATEGORY_LIST_REQUEST_ERROR',

    UPDATE_SUPPLIES_CATEGORY_DETAIL_REQUEST: 'UPDATE_SUPPLIES_CATEGORY_DETAIL_REQUEST',
    UPDATE_SUPPLIES_CATEGORY_DETAIL_REQUEST_SUCCESS: 'UPDATE_SUPPLIES_CATEGORY_DETAIL_REQUEST_SUCCESS',
    UPDATE_SUPPLIES_CATEGORY_DETAIL_REQUEST_ERROR: 'UPDATE_SUPPLIES_CATEGORY_DETAIL_REQUEST_ERROR',
    UPDATE_SUPPLIES_CATEGORY_DETAIL_REQUEST_STATUS: 'UPDATE_SUPPLIES_CATEGORY_DETAIL_REQUEST_STATUS',

    ADD_SUPPLIES_ITEM_REQUEST: 'ADD_SUPPLIES_ITEM_REQUEST',
    ADD_SUPPLIES_ITEM_REQUEST_SUCCESS: 'ADD_SUPPLIES_ITEM_REQUEST_SUCCESS',
    ADD_SUPPLIES_ITEM_REQUEST_ERROR: 'ADD_SUPPLIES_ITEM_REQUEST_ERROR',
    ADD_SUPPLIES_ITEM_REQUEST_STATUS: 'ADD_SUPPLIES_ITEM_REQUEST_STATUS',

    SUPPLIES_ITEM_LIST_REQUEST: 'SUPPLIES_ITEM_LIST_REQUEST',
    SUPPLIES_ITEM_LIST_REQUEST_SUCCESS: 'SUPPLIES_ITEM_LIST_REQUEST_SUCCESS',
    SUPPLIES_ITEM_LIST_REQUEST_ERROR: 'SUPPLIES_ITEM_LIST_REQUEST_ERROR',

    SUPPLIES_ITEM_DETAIL_REQUEST: 'SUPPLIES_ITEM_DETAIL_REQUEST',
    SUPPLIES_ITEM_DETAIL_REQUEST_SUCCESS: 'SUPPLIES_ITEM_DETAIL_REQUEST_SUCCESS',
    SUPPLIES_ITEM_DETAIL_REQUEST_ERROR: 'SUPPLIES_ITEM_DETAIL_REQUEST_ERROR',

    CONSUME_SUPPLIES_ITEM_REQUEST: 'CONSUME_SUPPLIES_ITEM_REQUEST',
    CONSUME_SUPPLIES_ITEM_REQUEST_SUCCESS: 'CONSUME_SUPPLIES_ITEM_REQUEST_SUCCESS',
    CONSUME_SUPPLIES_ITEM_REQUEST_ERROR: 'CONSUME_SUPPLIES_ITEM_REQUEST_ERROR',
    CONSUME_SUPPLIES_ITEM_REQUEST_STATUS: 'CONSUME_SUPPLIES_ITEM_REQUEST_STATUS',

    UPDATE_SUPPLIES_ITEM_STOCK_REQUEST: 'UPDATE_SUPPLIES_ITEM_STOCK_REQUEST',
    UPDATE_SUPPLIES_ITEM_STOCK_REQUEST_SUCCESS: 'UPDATE_SUPPLIES_ITEM_STOCK_REQUEST_SUCCESS',
    UPDATE_SUPPLIES_ITEM_STOCK_REQUEST_ERROR: 'UPDATE_SUPPLIES_ITEM_STOCK_REQUEST_ERROR',
    UPDATE_SUPPLIES_ITEM_STOCK_REQUEST_STATUS: 'UPDATE_SUPPLIES_ITEM_STOCK_REQUEST_STATUS'
}
